import lazyload from '../lazyload/lazyload';

lazyload.js('https://wstatic.plaync.co.kr/common/js/uikit/modal/ModalPopup.min.js');

let openedLayer;
let body = $('body');

$(document).on('click.promo.layer', '[data-layer="middle"]', function(e){
    e.preventDefault();
    let targetName = this.hash || $(e.target).data('href');

    if(!body.data(`layerData${targetName}`)) {
        let data = new nc.ui.Modal({
            isBackdropClickClose: true,
            isEsc: true,
            backdropCss: {'opacity': $(e.target).data('opacity') || '0.8'},
            content: $(this.hash || $(e.target).data('href'))
        });
        body.data(`layerData${targetName}`, data);
    }
    openedLayer = body.data(`layerData${targetName}`);
    body.data(`layerData${targetName}`).show();
});

$(document).on('click.promo.layer', '[data-layer="top"]', function(e){
    e.preventDefault();

    let targetName = this.hash || $(e.target).data('href');

    if(!body.data(`layerData${targetName}`)) {
        let data = new nc.ui.Modal({
            isBackdropClickClose: true,
            isEsc: true,
            backdropCss: {'opacity': $(e.target).data('opacity') || '0.8'},
            content: $(this.hash || $(e.target).data('href')),
            top: 'auto',
            isMove: true
        });
        body.data(`layerData${targetName}`, data);
    }
    openedLayer = body.data(`layerData${targetName}`);
    body.data(`layerData${targetName}`).show();
});

$(document).on('click.promo.layer', '[data-layer="close"]', function(e){
    e.preventDefault();

    openedLayer.hide();
});

let open = (selector, position = 'middle') =>{
    let targetName = selector;

    if(!body.data(`layerData${targetName}`)) {
        let data = new nc.ui.Modal({
            isBackdropClickClose: true,
            isEsc: true,
            top: `${position === 'middle' ? 0 : 'auto'}`,
            isMove: `${position !== 'middle'}`,
            backdropCss: {'opacity': $(targetName).data('opacity') || '0.8'},
            content: $(targetName)
        });
        body.data(`layerData${targetName}`, data);
    }
    openedLayer = body.data(`layerData${targetName}`);
    body.data(`layerData${targetName}`).show();
};

let close = () =>{
    openedLayer.hide();
};

export default {
    open,
    close
};